import { useContext } from 'react';
import ModalContext from '@sp/ui/context/ModalContext';

const useModal = () => useContext(ModalContext);

export default useModal;
